import React, {Component} from 'react';
import {
    Container,
    Col,
    Row, Breadcrumb, BreadcrumbItem
} from "mdbreact";
import {Link} from "react-router-dom";
import {Player} from 'video-react';

import "./../../../node_modules/video-react/dist/video-react.css";
import "./../../assets/media/intro.mp4";
import "./../../assets/media/intro.jpg";


export default class HelpItem extends Component {
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/how-it-works">سوالات متداول</Link></BreadcrumbItem>
                        <BreadcrumbItem active>عنوان آموزش</BreadcrumbItem>
                    </Breadcrumb>

                    <div className="white p-3 rtl">
                        <Row>
                            <Col md="12">
                                <h1 className="teal-text mt-3 mb-4">عنوان آموزش</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" className="w-100">
                                <Player
                                    playsInline
                                    poster="./../../assets/media/intro.jpg"
                                    src="./../../assets/media/intro.mp4"
                                />
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-5">
                            <Col md="12" className="w-100">
                                <h3>پاراگراف اول</h3>
                                <p className="text-justify rtl">
                                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                    است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط
                                    فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم
                                    ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی
                                    تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                                </p>
                                <h3>پاراگراف دوم</h3>
                                <p className="text-justify rtl">
                                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                    است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط
                                    فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم
                                    ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی
                                    تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                                </p>
                            </Col>
                        </Row>
                    </div>
                </Container>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/faq/HelpItem.js